/**
 * Wrapper de localStorage para datos de UI (userData, embarque seleccionado).
 * NO se usa para tokens de sesión.
 */
export const storage = {
    getItem: (key: string): string | null => localStorage.getItem(key),
    setItem: (key: string, value: string): void => localStorage.setItem(key, value),
    deleteItem: (key: string): void => localStorage.removeItem(key),
};
